module.exports = __webpack_public_path__ + "static/media/reviewQuestions3.b2788985.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reviewQuestions3.png
// module id = 1485
// module chunks = 0